import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";
import "../assets/styles/About.css";
import MainScrollText from "./MainScrollText";
import Card from "./Card";
import PersonCardSlider from "./PersonCardSlider";
import useStore from "../context/store";
gsap.registerPlugin(ScrollTrigger);
const AboutUs = () => {
  const textRef = useRef(null);
  const containerRef = useRef(null);
  const sectionRef = useRef(null);

  const data = useStore((state) => state);

  useEffect(() => {
    const cards = gsap.utils.toArray(".product-card1");

    gsap.fromTo(
      cards,
      { opacity: 0, y: 50 },
      {
        opacity: 1,
        y: 0,
        duration: 1,
        stagger: 0.2,
        ease: "power3.out",
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 80%",
          end: "top 50%",
          toggleActions: "play none none none",
        },
      }
    );
  }, []);

  useGSAP(
    () => {
      gsap.fromTo(
        textRef.current,
        {
          x: "20%",
          opacity: 1,
        },
        {
          x: "-10%",
          duration: 15,
          ease: "power3.out",
          scrollTrigger: {
            trigger: containerRef.current,
            start: "top center",
            end: "bottom center",
            scrub: 4,
          },
        }
      );
    },
    { scope: containerRef }
  );


  return (
    <div ref={containerRef} className="relative bg-gray-300">
      {/* About Us Section */}
      <div className="product-card-container pt-36 mx-auto text-left px-6 md:px-0 font-mono">
        <h1 className="uppercase text-xl font-semibold pb-6">
          {data.store.aboutData.heading_about}
        </h1>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <h1 className="text-6xl md:text-7xl font-semibold leading-tight">
            {data.store.aboutData.heading_title}
          </h1>
          <div className="space-y-7 text-lg md:text-2xl leading-relaxed font-poppins">
            {data.store.aboutData.heading_description_1.map((des, index) => (
              <p key={index}>{des}</p>
            ))}
          </div>
        </div>
      </div>

      {/* Image & Large Text Section */}
      <section className="pb-100 pt-100 mt-20 relative overflow-hidden font-poppins">
        <div className="inter500 text-and-image-overlap__bg-text uppercase">
          <div ref={textRef}>{data.store.aboutData.large_text}</div>
        </div>
        <div className="relative w-full h-full">
          <div className="text-and-image-overlap__content"></div>
          <div className="text-and-image-overlap__image">
            <picture>
              <source
                media="(min-width: 480px)"
                srcset={data.store.aboutData.image}
              />
              <img
                decoding="async"
                src={data.store.aboutData.image}
                alt=""
                className="object-cover w-full h-full"
              />
            </picture>
          </div>
        </div>
        <div className="product-card-container pt-16 mx-auto text-left px-6 md:px-0">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div></div>
            <div className="space-y-7 text-lg md:text-2xl leading-relaxed font-poppins">
              {data.store.aboutData.heading_description_2.map((des, index) => (
                <p key={index}>{des}</p>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section
        className="product-card-container pt-20 pb-28 mx-auto text-left px-6 md:px-0 font-poppins"
        ref={sectionRef}
      >
        <div className="grid md:grid-cols-3 gap-8 ">
          {data.store.aboutData.valueCards.map((card, index) => (
            <Card key={index} {...card} />
          ))}
        </div>
      </section>

      <section className="bg-black">
        <MainScrollText data={data.store.aboutData.mainScrollText} />
      </section>

      <section className="py-20 text-left px-6 md:px-0 bg-gray-300 font-mono">
        <div className="product-card-container mx-auto">
          <h1 className="text-5xl font-semibold">
            {data.store.aboutData.teamHeading}
          </h1>
          <PersonCardSlider teamInfo={data.store.aboutData.teamInfo} />
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
